import { Box } from '@mui/material'

const ConnectorAtom = () => {
	return (
		<Box flex="1 1 auto" height={{ xs: 2, md: 'inherit' }} ml={{ md: 3.75 }}>
			<Box
				component="span"
				display="block"
				width={{ md: 2 }}
				height={{ xs: 1, md: 'inherit' }}
				minHeight={{ md: 36, lg: 48, xl: 54 }}
				bgcolor="primary.main"
				sx={{ transform: { md: 'translateX(-50%)' } }}
			/>
		</Box>
	)
}

export default ConnectorAtom
